import CssBaseline from '@mui/material/CssBaseline';

import {AppTopBar} from 'components/Navigate/AppTopBar/AppTopBar';

import {RightDrawer} from 'components/Navigate/Drawers/RightDrawer';
import ModalMenu from 'components/Navigate/ModalMenu';
import {Box, Toolbar} from '@mui/material';
import {APP_TOP_BAR_HEIGHT} from 'appConstants';
import {Outlet} from 'react-router-dom';
import {Suspense} from 'react';
import {Loading} from 'components/Loading';

export const BaseLayout = () => {
  return (
    <Box display="flex">
      <CssBaseline />
      <AppTopBar />
      <Box flexGrow={1}>
        <Toolbar style={{minHeight: `${APP_TOP_BAR_HEIGHT}px`}} />
        <Suspense fallback={<Loading />}>
          <Outlet />
        </Suspense>{' '}
      </Box>
      <RightDrawer />
      <ModalMenu />
    </Box>
  );
};
